import MatchPlayContentSection from './match-play-content-section'

export default MatchPlayContentSection
